import { ToastContainer, toast } from 'react-toastify';

import loading from "../../../assets/images/loading.gif"
import { useState, useEffect, FormEvent } from "react";
import { makeGetRequest, makePatchRequest } from "../../../request";
import { useDispatch } from "react-redux";
import { customStyles, formatDateTime, getShipmentStatusIndex, LCADocumentsRequiredForPayment, ShipmentStatus } from "../../../helpers";
import Pagination from "../../../components/Pagination";
import Layout from '../../Layout';
import Modal from "react-modal"
import { useLocation, useNavigate } from 'react-router-dom';
import { setPageContext } from 'store/pageContext';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const ShippingDocuments =  () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const statusBeforeNavigation = location.state as { status: number };
    const queryParams = new URLSearchParams(window.location.search)
    const [shippingDocuments, setRecords] = useState<Record <string, any>>([]) 
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };
    
    const [searchValue, setSearchValue] = useState("")
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) {setSearchValue(""); setStatus(1)}
    }

    const handleChange = (event: any) => {        
        const { name, value } = event.target //get data form each input on change

        setFormData(values => ({...formData, [name]: value})) //set retrieved values to "formData" object 

        if(name === "receiver") getShippingChatHistory(value)
    }
    
    const [formData, setFormData] = useState({
        documentName: "",
        document: "",
        shippingDocumentId: "", 
        freightForwarderId: "", 
        localClearingAgentId: "",
        portOfficerStatus: "",
        receiver: "",
        comment: "",
        attachments: []
    })

    const [dateFormData, setDateFormData] = useState({
        shippingDocumentId: "", 
        date: ""
    })

    const clearData = () => {
        setFormData({
            documentName: "",
            document: "",
            shippingDocumentId: "",
            freightForwarderId: "", 
            localClearingAgentId: "",
            portOfficerStatus: "",
            receiver: "",
            comment: "",
            attachments: []
        })
    }

    const [isLoading, setIsLoading] = useState(false)
    const [isChatLoading, setIsChatLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [openChatModal, setOpenChatModal] = useState(false)
    const [status, setStatus] = useState<number | null>(statusBeforeNavigation?.status ? statusBeforeNavigation.status : queryParams.get("status") ? Number(queryParams.get("status")) : 1)
    const [openChatHistory, setOpenChatHistory] = useState(false)
    const getShippingDocuments = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocuments",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                OrderBy: 2,
            }
        };
        if(searchValue) {request.params.SearchString = searchValue; setStatus(null);}

        let statusName = ""
        switch (status) {
            case 1:
                statusName = "New Shipment"
                break;

            case 2:
                statusName = "Rejected"
                break;

            case 3:
                statusName = "Draft Uploaded,Draft Approved"
                break;

            case 4:
                statusName = "Final Uploaded,Final Approved,Shipped"
                break;

            case 5:
                statusName = "LCA Assigned,Vessel Arrival Confirmation,Custom Physical Examination Ongoing,Port Officer Desk,Ready To Transfer To Total Energies Yard,Awaiting Custom Duty Payment,LCA Completed Upload"
                break;

            case 6:
                statusName = "Shipment Delivered"
                break;

            case 7: 
                statusName = "Draft Uploaded"
                break;

            case 8: 
                statusName = "Draft Approved"
                break;

            case 9: 
                statusName = "Final Uploaded"
                break;

            case 10: 
                statusName = "Final Approved"
                break;

            default:
                statusName = "New Shipment"
                break;
        }
        if(status) request.params.status = statusName
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRecords(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.msg)
            );
    }

    const handleSendChat = (e: FormEvent) => {
        e.preventDefault()
        setIsSubmitting(true)
        var request: Record<string, any> = {
            what: "AddCommentForShippingDocuments",
            data: {
                id: formData.shippingDocumentId,
                comment: formData.comment,
                sender: "ShippingOfficer",
                senderRole: "Shipping Officer",
                receiver: formData.receiver === "Freight Forwarder" ? formData.freightForwarderId :
                            formData.receiver === "Local Clearing Agent" ? formData.localClearingAgentId : "",
                receiverRole: formData.receiver === "Freight Forwarder" ? "Freight Forwarder" :
                            formData.receiver === "Local Clearing Agent" ? "Local Clearing Agent" : ""
            }
        };
        
        makePatchRequest(request)
            .then((response: any) => {
                setIsSubmitting(false)
                clearData()
                toast.success("Chat Sent Successfully!")
                setOpenChatHistory(false)
                getShippingDocuments()
            })
            .catch((error:any) => 
                {toast.error(error); setIsSubmitting(false)}
            );
    }

    const [chats, setChats] = useState<Record <string, any>>([])
    const getShippingChatHistory = (selectedReceiver: string) => {
        setIsChatLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocumentChatHistory",
            params: {
                shippingDocumentId: formData.shippingDocumentId,
                sender: "ShippingOfficer",
                // sender: "TransitOfficer",
                receiver: selectedReceiver === "Freight Forwarder" ? formData.freightForwarderId :
                            selectedReceiver === "Local Clearing Agent" ? formData.localClearingAgentId : ""
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsChatLoading(false)
                const res = response.data.data
                setChats(res.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()))
            })
            .catch((error:any) => 
                {toast.error(error.msg); setIsChatLoading(false)}
            );
    }

    const [isUpdateModal, setIsUpdateModal] = useState(false)
    const handleSetTime = (event: FormEvent) => { 
        event.preventDefault()      
        setIsSubmitting(true)
        var request:Record<string, any> = {
            what: "setActualTimeOfArrival",
            data: {
                shippingDocumentId: formData.shippingDocumentId,
                date: dateFormData.date
            }
        };      

        makePatchRequest(request)
            .then((response: any) => {  
                setIsSubmitting(false)                   
                toast.success(response.msg) 
                setIsUpdateModal(false) 
                clearData()
                getShippingDocuments()                            
            })
            .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
    }
   
    const [selectedRow, setSelectedRow] = useState("")
    const [toggleExpand, setToggleExpand] = useState(false)
    const row = shippingDocuments?.map((data: any, index:number) => {
                    return (
                        <>
                        <tr key={index}>
                            <td onClick={() => {setSelectedRow(data.id); setToggleExpand(!toggleExpand)}} style={{paddingLeft: "8px", cursor: "pointer", }} 
                                className="fw-600 text-blue">
                                <div className="d-flex" style={{textWrap: "nowrap"}}>
                                    {(selectedRow !== data.id || !toggleExpand) && <span className="material-symbols-rounded">expand_more</span>}
                                    {selectedRow === data.id && toggleExpand && <span className="material-symbols-rounded">expand_less</span>}
                                    { currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }
                                </div>
                            </td>                            
                            <td>{ data.referenceNumber ?? "N/A" }</td>
                            <td>{ data.shippingNumber?.split('-')[1] }</td>
                            <td>{ data.consolidatedCommercialInvoice?.modeOfShipping } | { data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.consignee }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.destinationPlant }</td>
                            {(status === 5 || status === 6 || !status ) && <td>{ data?.localClearingAgent?.companyName }</td>}
                            <td>
                                <div className='d-flex-2'>
                                    <span className='material-symbols-rounded' style={{fontSize: "16px"}}>calendar_month</span> 
                                    <span>{formatDateTime(data.estimatedTimeOfDeparture).substring(0, 10)}</span>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex-2'>
                                    <span className='material-symbols-rounded' style={{fontSize: "16px"}}>calendar_month</span>
                                    <span>{formatDateTime(data.estimatedTimeOfArrival).substring(0, 10)}</span>                                    
                                </div>    
                            </td>  
                            {data.actualTimeOfArrival && <td>
                                <div className='d-flex-2'>
                                    <span className='material-symbols-rounded text-blue' style={{fontSize: "16px", cursor: "pointer"}}
                                    onClick={() => {setIsUpdateModal(true); setFormData({...formData, shippingDocumentId: data.id})}}>edit</span> 
                                    <span>{formatDateTime(data.actualTimeOfArrival).substring(0, 10)}</span>
                                </div>
                            </td>}
                            {!data.actualTimeOfArrival && <td>
                                <button className='blue-text d-flex-2' style={{padding: 0}}
                                    onClick={() => {setIsUpdateModal(true); setFormData({...formData, shippingDocumentId: data.id})}} 
                                    >
                                    <span className='material-symbols-rounded' style={{fontSize: "16px"}}>edit_calendar</span> 
                                    <span>Set Date</span>
                                </button>                                
                            </td>}
                            {(status===3 || status===4) &&
                                <td><span className={data.currentStatus.includes("Uploaded") ? "status yellow" : "status green"}>{data.currentStatus === "Shipped" ? "Final Approved" : data.currentStatus }</span></td>
                            }
                            <td>
                                <div className="dropdown">
                                    <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                                    <div className="dropdown-content">
                                        <button onClick={() => 
                                            {navigate(`/${window.location.pathname.split('/')[1]}/shippingdocuments/${data.id}`, {state: {status: status}} );
                                            dispatch(setPageContext({url: ""}))}}
                                        >View Documents</button>

                                        <button onClick={() => {setSelectedRow(data.id); setToggleExpand(true)}}
                                        >View Status</button>                                        

                                        {(data?.vesselName // to confirm the FF has shipped 
                                        || (data?.localClearingAgentId && LCADocumentsRequiredForPayment.every((document: string) => data.shippingDocumentAttachments.some((attachment: any) => attachment.documentName === document))) //to confirm if LCA has uploaded all documents required for payment
                                        ) &&
                                        <button onClick={() => 
                                            {navigate(`/${window.location.pathname.split('/')[1]}/shippingdocuments/certificatesofcompletion`, {state: {status: status, shippingDocumentId: data?.id, }} )}}
                                        >View Certificate(s)</button>}

                                        <button 
                                            onClick={() => {setOpenChatHistory(true); 
                                            setFormData({...formData, shippingDocumentId: data.id, freightForwarderId: data.freightForwarderId, localClearingAgentId: data.localClearingAgentId, attachments: data.shippingDocumentAttachments, portOfficerStatus: data.portOfficerStatus})}}>
                                            Send | View Chats
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        {selectedRow === data.id && toggleExpand && 
                            <>
                                <td colSpan={12} style={{backgroundColor: "white"}}>
                                    <Box sx={{ width: '95%', margin: "16px 0" }}>
                                        <Stepper activeStep={getShipmentStatusIndex(data.currentStatus)} alternativeLabel>
                                            {ShipmentStatus().map((label: any, index: number) => {
                                                    const inactiveSteps = [];
                                                    const completedStatuses: string[] = [];
                                                    if (data.allDocumentsApprovedByTransit !== true) inactiveSteps.push("LCA Completed Upload");

                                                    if(data.clearingProcessStatuses.find((status: any) => status.toStatus !== "Awaiting Custom Duty Payment")) {
                                                        inactiveSteps.push("Awaiting Custom Duty Payment");
                                                    }

                                                    if(data.clearingProcessStatuses.every((status: any) => status.toStatus !== "Rejected") || data.clearingProcessStatuses.length === 0) {
                                                        inactiveSteps.push("Rejected");
                                                    }

                                                    if(data.clearingProcessStatuses.every((status: any) => status.toStatus !== "Port Officer Desk")) {
                                                        inactiveSteps.push("Port Officer Desk");
                                                    }

                                                    if(data.clearingProcessStatuses.some((status: any) => status.toStatus === "Draft Uploaded")){
                                                        completedStatuses.push("Draft Uploaded")
                                                    }

                                                    if(data.clearingProcessStatuses.some((status: any) => status.toStatus === "Final Uploaded")){
                                                        completedStatuses.push("Draft Uploaded", "Draft Approved", "Final Uploaded")
                                                    }

                                                    const getRejected: any = () => {
                                                        if(data.clearingProcessStatuses.some((status: any) => status.toStatus === "Draft Uploaded")) return 3
                                                        else return 5
                                                    }
                                                    
                                                    const isInactive = inactiveSteps.includes(label.name);
                                                    const isCompleted = !isInactive && (index < getShipmentStatusIndex(data.currentStatus) || 
                                                                        completedStatuses.includes(label.name));
                                                    const isActive = data.currentStatus !== "Rejected" ? getShipmentStatusIndex(data.currentStatus) === index
                                                                    : getShipmentStatusIndex(getRejected) === index;
                                                    
                                                    return (
                                                        <Step 
                                                            key={index}
                                                            completed={isCompleted}
                                                            active={isActive}
                                                        >
                                                            <StepLabel
                                                                StepIconProps={{
                                                                    sx: {
                                                                        color: isInactive ? '#b0b0b0' : 
                                                                            isCompleted ? '#4caf50' : 
                                                                            isActive ? '#1976d2' : '#bdbdbd',
                                                                        '& .MuiStepIcon-text': {
                                                                            fill: isInactive ? 'white' : 
                                                                                isCompleted ? 'white' : 'white'
                                                                        }
                                                                    }
                                                                }}
                                                                sx={{
                                                                    '& .MuiStepLabel-label': {
                                                                        textDecoration: isCompleted ? 'none' : 'none',
                                                                    }
                                                                }}
                                                            >
                                                                {label.name}
                                                            </StepLabel>
                                                        </Step>
                                                    );
                                                })}
                                        </Stepper>
                                    </Box>
                                </td>
                            </>
                        }
                        </>
                    )
                })
    
    useEffect(() => {
        getShippingDocuments()// eslint-disable-next-line
    }, [currentPage, itemsPerPage, searchValue, status])

    const page = "Shipping Documents"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Shipping Number" onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>
                            <div className='d-flex' style={{gap: "16px"}}>
                                <div className="d-flex page-filter">
                                    <span style={{fontSize: "12px", color: "#3e3e3e", fontWeight:"500"}}> Filter By </span>
                                    <div className={status === 1 ? "orange active": "orange"} onClick={() => {setStatus(1); setCurrentPage(1)}}>
                                    {status === 1 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        New Shipment</div>

                                    <div className={status === 2 ? "red active": "red"} onClick={() => {setStatus(2); setCurrentPage(1)}}>
                                    {status === 2 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Rejected</div>

                                    <div className={(status === 3 || status === 7 || status === 8) ? "green active": "green"} onClick={() => {setStatus(3); setCurrentPage(1)}}>
                                    {(status === 3 || status === 7 || status === 8) && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Draft</div>

                                    <div className={(status === 4 || status === 9 || status === 10) ? "blue active": "blue"} onClick={() => {setStatus(4); setCurrentPage(1)}}>
                                    {(status === 4 || status === 9 || status === 10) && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Final</div>

                                    <div className={status === 5 ? "purple active": "purple"} onClick={() => {setStatus(5); setCurrentPage(1)}}>
                                    {status === 5 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        LCA Assigned</div>

                                    <div className={status === 6 ? "grey active": "grey"} onClick={() => {setStatus(6); setCurrentPage(1)}}>
                                    {status === 6 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Shipment Delivered</div>
                                </div>
                            </div>
                        </div> 

                        {(status === 3 || status === 7 || status === 8) && <div className='main-inner-top' style={{borderTop: "1px solid #d9d9d9"}} onChange={() => setStatus}>
                            <select value={status} className='right-item' onChange={(e) => setStatus(Number(e.target.value))} >
                                <option key="0" value={3}>All Draft</option>                         
                                <option key="1" value={7}>Draft Uploaded</option>                         
                                <option key="2" value={8}>Draft Approved</option>                         
                            </select>    
                        </div>}   

                        {(status === 4 || status === 9 || status === 10) && <div className='main-inner-top' style={{borderTop: "1px solid #d9d9d9"}} onChange={() => setStatus}>
                            <select value={status} className='right-item' onChange={(e) => setStatus(Number(e.target.value))} >
                                <option key="0" value={4}>All Final</option>                         
                                <option key="1" value={9}>Final Uploaded</option>                         
                                <option key="2" value={10}>Final Approved</option>                         
                            </select>    
                        </div>}                          

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th>BL/AWB Number</th>
                                        <th>Shipment Number</th>
                                        <th>Mode | Currency</th>
                                        <th>Consignee</th>
                                        <th>Destination Plant</th>
                                        {(status === 5 || status === 6 || !status) && <th>Local Clearing Agent</th>}
                                        <th title='Estimated Time of Departure'>ETD</th>
                                        <th title='Estimated Time of Arrival'>ETA</th>
                                        <th title='Actual Time of Arrival'>ATA</th>
                                        {(status===3 || status===4) && <th>Document Status</th>}
                                        <th style={{width: "116px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            shippingDocuments?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                                startIndex={startIndex} />
                        </div>
                    </div>                 
                </div>      

                <Modal isOpen={openChatModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Send Chat</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setOpenChatModal(false); setIsSubmitting(false); clearData()}}>close</span>
                    </div>
                    <form onSubmit={handleSendChat}>
                    <div className="modal-body">
                        <div>
                            <label>
                                <span className="errorX mr-2">*</span> Reciever
                            </label>
                            <select value={formData.receiver} name="receiver" 
                                onChange={(event) => setFormData({...formData, receiver: event.target.value})} required>
                                <option value="" disabled>--Select--</option>
                                <option value="Freight Forwarder">Freight Forwarder</option>
                                <option value="Local Clearing Agent">Local Clearing Agent</option>
                            </select>

                            <div className='mt-1'>
                                <label>
                                    <span className="errorX mr-2">*</span> Message
                                </label>  
                                <textarea 
                                    className="mt-1" 
                                    name="comment" 
                                    placeholder="Write a message..." 
                                    rows={4} 
                                    maxLength={300}
                                    onChange={handleChange}
                                    value={formData.comment} 
                                    required ></textarea>
                            </div>
                        </div> 
                        <small style={{fontSize: "10px"}} className={formData.comment.length >= 300 ? "mt-1 error" : "mt-1"}>{formData.comment.length}/300 Characters</small> 
                    </div>
                    <div className="modal-footer bt-1">
                        <button type="button" className="custom-button grey-outline"
                            onClick={() => {setOpenChatModal(false); clearData()}}>Cancel</button>
                        <button type="submit" 
                        disabled={isSubmitting}
                        className="custom-button orange">{isSubmitting ? "Loading..." : "Send Chat"}</button>
                    </div>
                    </form>
                </Modal>

                <Modal isOpen={openChatHistory} style={customStyles} className="modal modal-7" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Chats</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setOpenChatHistory(false); setIsSubmitting(false); clearData()} }>close</span>
                    </div>
                    <div className="modal-body" style={{ minHeight: "300px"}}>
                        <label><span className='errorX mr-2'>*</span>Entity</label>
                        <select value={formData.receiver} onChange={handleChange} name='receiver' required>
                            <option value="" disabled>--Select--</option>
                            <option value="Freight Forwarder">Freight Forwarder</option>
                            <option value="Local Clearing Agent">Local Clearing Agent</option>
                        </select>

                        {!formData.receiver && <p>No source selected yet.</p>}
                        {(!isChatLoading && formData.receiver && !chats.length) && <p>No Chats Found.</p>}

                        {!isChatLoading && formData.receiver && 
                        <div className='chat-container mt-1' style={{maxHeight: "250px"}}>
                            {chats.map((chat: any, index: number) => {
                                return (
                                    <div key={index} className={`chat-dialog ${chat.sender === "ShippingOfficer" ? "right" : "left"}`}>
                                        <label className='title'>{chat.sender === "ShippingOfficer" ? "Transit Team" : formData.receiver}</label>
                                        <p>{chat.message}</p>
                                        <span className='date'>{formatDateTime(chat.createdDate)}</span>
                                    </div>
                                )
                            })}
                        </div>}

                        {isChatLoading && 
                        <div className="loader">
                            <img src={loading} alt="loading" />
                            <p className="d-flex-center">Loading Chats...</p>
                        </div>}
                    </div>
                    {/* Don't allow sending of chat to Freight Forwarder after LCA Assignment */}
                    {((formData?.localClearingAgentId === null && formData.receiver === "Freight Forwarder")
                    || (formData?.localClearingAgentId !== null && formData.receiver === "Local Clearing Agent")) &&
                    formData?.portOfficerStatus === null &&
                    <form onSubmit={handleSendChat}>
                    <div className="modal-footer">
                        <textarea 
                            name="comment" 
                            placeholder={`Message for ${formData.receiver === "Freight Forwarder" ? "Freight Forwarder" : formData.receiver === "Local Clearing Agent" ? "Local Clearing Agent" : ""}...`}
                            rows={4} 
                            maxLength={300}
                            onChange={handleChange}
                            value={formData.comment} 
                            required ></textarea>
                        <button type="submit" 
                        disabled={isSubmitting || !formData.comment}
                        className="custom-button orange">{isSubmitting ? "Loading..." : "Send"}</button>
                    </div>
                    <small style={{fontSize: "10px"}} className={formData.comment.length >= 300 ? "mt-1 error" : "mt-1"}>{formData.comment.length}/300 Characters</small>
                    <div className="alert alert-warning" style={{margin: "12px 0 0 0 ", padding: "8px", width: "auto", alignItems: "start"}}>
                        <span className="material-symbols-outlined mr-2" style={{color: "#e4b14b", fontSize: "16px"}}>warning</span>
                        <div style={{fontSize: "10.5px"}}>
                            <p style={{margin: 0, marginBottom: "4px"}}>Keep in mind information</p>
                            <span style={{fontWeight: "300"}}>Sending a chat requires the receiver to reupload the stated shipping document(s) before approval. Avoid initiating if no reupload is needed.</span>
                        </div>
                    </div>
                    </form>}
                </Modal>
                <Modal isOpen={isUpdateModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Set Date</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setIsUpdateModal(false); setDateFormData({...dateFormData,date: ""})} }>close</span>
                    </div>
                    <form onSubmit={handleSetTime}>                    
                    <div className="modal-body" style={{ minHeight: "80px"}}>
                        <div>
                            <label>
                                <span className="errorX mr-2">*</span>
                                Actual Time of Arrival
                            </label>
                            <input 
                                type='date' 
                                required
                                value={dateFormData.date} 
                                onChange={(e) => setDateFormData({...dateFormData, date: e.target.value})} />
                        </div>
                        
                    </div>
                    <div className="modal-footer bt-1">
                        <button type='button' className="custom-button grey-outline"
                            onClick={() => {setIsUpdateModal(false); setDateFormData({...dateFormData,date: ""})}}>Cancel</button>
                        <button 
                            disabled={isSubmitting} 
                            type="submit" 
                            className="custom-button orange">{isSubmitting ? "Loading..." : "Submit"}</button>
                    </div>
                    </form>
                </Modal>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default ShippingDocuments